export const SET_SEARCH_REFINEMENT = '/search/SET_SEARCH_REFINEMENT';
export const SET_SEARCH_PAGE = '/search/SET_SEARCH_PAGE';
export const SET_SEARCH_RESULTS  = '/search/SET_SEARCH_RESULTS';